import { useSelector } from "react-redux";
import { Row, Card } from "react-bootstrap";
import QuizLink from "./QuizLink";

const Challenges = ({ user }) => {
    const { quizChallenges } = useSelector(state => state.quizAuth);

    return (
        <Card className="challenges my-4 shadow-sm">
            <Card.Header className="card-header-dark p-0">
                <h3>Challenges</h3>
            </Card.Header>
            <Card.Body className="d-flex flex-column align-items-center text-center p-1">
                {quizChallenges && quizChallenges.map((challenge, index) => (
                    <Row key={`${challenge.topic}-${index}`}>
                        <QuizLink challenge={challenge} />
                    </Row>
                ))}
            </Card.Body>
        </Card>
    )
}

export default Challenges;